module.exports = __webpack_public_path__ + "static/img/default_avatar.4dbf5f08.jpg";